<template>
  <el-container style="height: 100vh; border: 1px solid #eee;">
      <el-menu :default-openeds="['1', '3']" router :default-active="$route.path" :collapse="isCollapse" class="el-menu-vertical-demo">
        <!-- <el-submenu index="1"> -->
          <!-- <template><i class="el-icon-menu" style="color: #fff;"></i><span slot="title">报表查询</span></template> -->
          <el-menu-item index="/FYSS"><i class="el-icon-document" style="color: #fff;"></i>讯联账号查询</el-menu-item>
          <el-menu-item index="/empower"><i class="el-icon-document" style="color: #fff;"></i>授权码</el-menu-item>
          <!-- <el-menu-item index="/ZC"><i class="el-icon-document" style="color: #fff;"></i>注册</el-menu-item> -->
          <!-- <el-menu-item index="/sale"><i class="el-icon-document" style="color: #fff;"></i>已注册飞鱼</el-menu-item> -->
          <el-menu-item index="/YSQ"><i class="el-icon-document" style="color: #fff;"></i>已申请速云</el-menu-item>
          <el-menu-item index="/ISM"><i class="el-icon-document" style="color: #fff;"></i>接口授权管理</el-menu-item>
          <el-menu-item index="/DogSoftware"><i class="el-icon-document" style="color: #fff;"></i>软狗号查询</el-menu-item>
          <el-menu-item index="/PTAM"><i class="el-icon-document" style="color: #fff;"></i>拍照事务账号管理</el-menu-item>
          <el-menu-item index="/BDYM"><i class="el-icon-document" style="color: #fff;"></i>绑定域名</el-menu-item>
          <el-menu-item index="/XGMM"><i class="el-icon-document" style="color: #fff;"></i>密码修改</el-menu-item>
          <el-menu-item index="/SystemCode"><i class="el-icon-document" style="color: #fff;"></i>小程序管理</el-menu-item>
          <!-- <el-menu-item index="/GYSBDYM"><i class="el-icon-document" style="color: #fff;"></i>供应链绑定域名</el-menu-item>
          <el-menu-item index="/CXTYSHDZD"><i class="el-icon-document" style="color: #fff;"></i>查询特约商户对账单</el-menu-item> -->
        <!-- </el-submenu> -->
      </el-menu>

    <el-container style="width: calc(100% - 200px)">
      <el-header v-if="!(path==='/')" style="width:100%;">
        <!-- <el-button type="primary" size="mini" plain @click="handleOpen" style="margin-top: 10px;" :class="isCollapse== true ? ' el-icon-s-unfold' : 'el-icon-s-fold' "></el-button> -->
        <!-- <span style="float: left; font-size: 25px; padding-left: 15PX;">报表查询系统</span> -->
        <!-- <span style="font-size: 14px ;padding-left: 50%;float: left; white-space:nowrap">{{nowDate}}</span> -->
        <div style="text-align: right; font-size: 14px ;">
          <!-- <span style="white-space:nowrap"><i class="el-icon-user-solid"></i>{{Name==""? Name: " 欢迎您，"+ Name + "！"}}</span> -->
          <!-- <el-divider direction="vertical" style="white-space:nowrap"></el-divider> -->
          <!-- <el-dropdown>
            <i style="color: #fff;" class="el-icon-setting"></i>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="changePassword">修改密码</el-dropdown-item>
              <el-dropdown-item @click.native="logoutFn">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown> -->
          <!-- <el-divider direction="vertical"></el-divider> -->
          <span style="padding-right: 40px;cursor: pointer;" @click="logoutFn"><i class="el-icon-switch-button"></i></span>
        </div>
      </el-header>

      <el-main class="containr">
        <slot name="main"></slot>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
  import Axios from "@/request/axiosReq"
export default {
  data() {
    const item = {
      date: '2016-05-02',
      name: '王小虎',
      address: '上海市普陀区金沙江路 1518 弄'
    };
    return {
      isCollapse: false,
      dialogFormVisible: false,
      close_modal: false,
      formLabelWidth: "100px",
      form: {
        userName: "",
        oldpassword: "",
        newpassword: "",
        confirmPassword: "",
      },
      tableData: Array(20).fill(item),
      path: '',
      user: "",
      Name: "",
      isManger: '-1',
      supplier: [],
      admin: [],
      salesman: [],
      nowDate: "", // 当前时间
    }
  },
  watch: {
    $route(to, from) {
      console.log(to, from)
      this.path = to.path
      this.clear(to.path);
    },
    dialogFormVisible(val, oldVal) {//普通的watch监听
      console.log("a: " + val, oldVal);
      if (val == true) {
        this.form.oldpassword = ""
        this.form.newpassword = ""
        this.form.confirmPassword = ""
        if (this.isManger != -1 && this.isManger != "") {
          this.form.userName = localStorage.getItem(`USER${this.isManger}`) || "";
        }
      }
    }
  },
  created() {
    // this.W_Get_Website_Books()
    // this.get_Add_Create_Table()
    // this.isManger = localStorage.getItem("isManger") || -1;
    // this.supplier = JSON.parse(localStorage.getItem("supplier") || '[]')
    // this.admin = JSON.parse(localStorage.getItem("admin") || '[]')
    // console.log(this.admin)
    // if (this.isManger != -1 && this.isManger != "") {
    //   this.form.userName = localStorage.getItem(`USER${this.isManger}`) || "";
    // }
    // //  NAME = JSON.parse(localStorage.getItem("admin")||'[]').length > 0 ? JSON.parse(localStorage.getItem("admin")||'[]')[0].name : ''
    // this.clear()
  },
  methods: {
    get_Add_Create_Table() {
      let param = {
        LoginCode: "Ossgclkkkdjklh554plkieEHKOJHJJKvs8752"
      }
      Axios.post(
        "/api/Add_Create_Table", param
      ).then((res) => {
        console.log(res);
      });
    },

    W_Get_Website_Books() {
      let ishttps = 'https:' == document.location.protocol ? true : false;
      let url = window.location.hostname;
      localStorage.setItem("url", url)
      console.log(ishttps, url)

      console.log(url)
      let param = {
        SystemCode: "aadffhy49954554g2d124jdsofds2",
        Two_Website: ishttps == true ? "https://" + "ssz31777.gnway.cc" : "http://"  + "ssz31777.gnway.cc"
      }
      Axios.post(
        // "/api/W_Get_Website_Books_Boos", param
        "/api/W_Get_Website_Books", param
      ).then((res) => {
        console.log(res);
        localStorage.setItem("port", res.GoPort)
        localStorage.setItem("Other_GoPath", res.Other_GoPath)
      });
    },
    handleOpen() {
      if (this.isCollapse == true) {
        this.isCollapse = false
      } else {
        this.isCollapse = true
      }
    },
    clear() {
      this.isManger = localStorage.getItem("isManger")
      if (this.isManger == 0) {
        this.Name = JSON.parse(localStorage.getItem("supplier") || '[]').length > 0 ? JSON.parse(localStorage.getItem("supplier") || '[]')[0].UserName : ''
      } else if (this.isManger == 1) {
        this.Name = JSON.parse(localStorage.getItem("admin") || '[]').length > 0 ? JSON.parse(localStorage.getItem("admin") || '[]')[0].UserName : ''
      } else if (this.isManger == 2) {
        this.Name = JSON.parse(localStorage.getItem("salesman") || '[]').length > 0 ? JSON.parse(localStorage.getItem("salesman") || '[]')[0].LoginName : ''
      }
      if (localStorage.getItem("isManger") == -1) {
        console.log(this.path)
        if (this.path != "/") {
          this.$message({
            type: "warning",
            message: "你还未登录，请先登录!",
          });
        }
        // this.$router.replace({ path: "/" });
        this.$router.replace({
          path: "/"
        }).catch(error => error);
      }
    },
    changePassword() {
      this.dialogFormVisible = true;
    },
    logoutFn() {

      console.log("点退了");
      //提示开始
      this.$confirm("你确定要退出吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "退出成功!",
            duration: 1000
          });
          sessionStorage.removeItem("LoginInfo")
          sessionStorage.removeItem("ZH")
          sessionStorage.removeItem("PW")
          this.$router.push({ path: "/" });
        })
        .catch(() => {
        });
      //提示结束
    },
    // 获取输入的新旧密码值
    getChangePwd: function () {
      console.log(
        "localStorage.getItem(isManger)",
        localStorage.getItem("isManger")
      );
      let isManger = localStorage.getItem("isManger");

      console.log("this.isManger", this.isManger);

      var that = this;
      //如果有一个为空的时候,直接return
      if (
        that.form.newpassword == "" ||
        that.form.confirmPassword == "" ||
        that.form.oldpassword == ""
      ) {
        this.$message({
          message: "请输入",
          type: "warning",
        });

        return;
      }

      console.log("that.form.oldpassword", that.form.oldpassword);
      //如果有不为空的时候进行判断
      if (
        that.form.oldpassword != "" &&
        that.form.newpassword != "" &&
        that.form.confirmPassword != ""
      ) {
        //如果新密码和确认密码不一致
        if (that.form.newpassword !== that.form.confirmPassword) {
          this.$message({
            message: "新密码和确认密码不一致",
            type: "warning",
          });
          return;
        }
        //如果旧密码 和 新密码，确认密码不一致
        if (
          that.form.oldpassword == that.form.newpassword &&
          that.form.confirmPassword
        ) {
          console.log("旧的密码和新的密码一样");
          this.$message({
            message: "旧密码和新密码一致",
            type: "warning",
          });
          return;
        }

        if (isManger == 1) {
          console.log("调用了后台");
          this.XH_UpdateLogin();
        } else if (isManger == 2) {
          console.log("调用了业务员");
          this.UpdateLoginEmp();
        } else if (isManger == 0) {
          console.log("调用了供应商");
          this.partners();
        }

        this.close_modal = true;
        that.dialogFormVisible = false;
        return;
        //遮罩

        //调用

        // this.UpdateLoginEmp();

        // that.form = {
        //   oldpassword: "",
        //   newpassword: "",
        // };
      }
    },
    //供应商
    partners() {
      let SupplierID = JSON.parse(localStorage.getItem("supplier") || '[]').length > 0 ? JSON.parse(localStorage.getItem("supplier") || '[]')[0].ID : ''
      // console.log("this.form.newpassword",this.form.newpassword)
      let paramts = {
        SupplierID: SupplierID,
        OldPassword: this.form.oldpassword,
        NewPWD: this.form.newpassword,
        LoginCode: "Ossgclkkkdjklh554plkieEHKOJHJJKvs8798",
      };

      Axios.post("/api/UpDate_LoginSupplier", paramts).then((res) => {
        if (res.ErrorMsg != "") {
          this.$message({
            message: res.ErrorMsg,
            type: "warning",
          });
        } else {
          // this.close_modal = true
          this.$message({
            message: "修改成功",
            type: "success",
          });
          let power = localStorage.getItem("isManger")
          localStorage.removeItem(`PASS${power}`);
        }

        console.log("供应商", res);
      });
    },

    //业务员
    UpdateLoginEmp() {
      let UserID = JSON.parse(localStorage.getItem("salesman") || '[]').length > 0 ? JSON.parse(localStorage.getItem("salesman") || '[]')[0].ID : ''
      //  console.log("localStorage.getItem(ID)",UserID)
      let paramts = {
        StaffID: UserID,
        OldPassword: this.form.oldpassword,
        NewPWD: this.form.newpassword,
        LoginCode: "Ossgclkkkdjklh554plkieEHKOJHJJKvs9987",
      };

      Axios.post("/api/UpDate_LoginRoot", paramts).then((res) => {
        console.log("后台的res", res);
        if (res.ErrorMsg != "") {
          this.$message({
            message: res.ErrorMsg,
            type: "warning",
          });
        } else {
          // this.close_modal = true
          this.$message({
            message: "修改成功",
            type: "success",
          });
          let power = localStorage.getItem("isManger")
          localStorage.removeItem(`PASS${power}`);
        }
      });
    },

    // 管理员
    XH_UpdateLogin() {
      let RootID = JSON.parse(localStorage.getItem("admin") || '[]').length > 0 ? JSON.parse(localStorage.getItem("admin") || '[]')[0].ID : ''
      let paramts = {
        RootID: RootID,
        OldPassword: this.form.oldpassword,
        NewPWD: this.form.newpassword,
        LoginCode: "Ossgclkkkdjklh554plkieEHKOJHJJKvs9987",
      };
      // delete paramts.EmpID;
      // paramts.LoginCode = "AYYjksaWW55496ujk6hfcvdfvs12236967"
      // console.log("XH_UpdateLogin paramts" ,paramts)
      Axios.post("/api/UpDate_LoginRoot", paramts).then((res) => {
        console.log("管理员的res", res);
        if (res.ErrorMsg != "") {
          this.$message({
            message: res.ErrorMsg,
            type: "warning",
          });
          return;
        }
        this.$message({
          message: "修改成功",
          type: "success",
        });
        let power = localStorage.getItem("isManger")
        localStorage.removeItem(`PASS${power}`);
        this.form = {
          oldpassword: "",
          newpassword: "",
          confirmPassword: "",
        };
      });
    },

    //时间
    currentTime() {
      setInterval(this.formatDate, 500);
    },
    formatDate() {
      let date = new Date();
      let year = date.getFullYear(); // 年
      let month = date.getMonth() + 1; // 月
      let day = date.getDate(); // 日
      let week = date.getDay(); // 星期
      let weekArr = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
      let hour = date.getHours(); // 时
      hour = hour < 10 ? "0" + hour : hour; // 如果只有一位，则前面补零
      let minute = date.getMinutes(); // 分
      minute = minute < 10 ? "0" + minute : minute; // 如果只有一位，则前面补零
      let second = date.getSeconds(); // 秒
      second = second < 10 ? "0" + second : second; // 如果只有一位，则前面补零
      this.nowDate = `${year}-${month}-${day} ${weekArr[week]} ${hour}:${minute}:${second}`;
    }
  },
  mounted() {
    this.path = this.$route.path,
      this.currentTime();
  },
  // 销毁定时器
  beforeDestroy() {
    if (this.formatDate) {
      clearInterval(this.formatDate); // 在Vue实例销毁前，清除时间定时器
    }
  }
};
</script>



<style lang="less" scoped>
body {
  margin: 0;
  padding: 0;
}
.el-header {
  background-color: #666666;
  color: #fff;
  line-height: 60px;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}

.el-aside {
  color: #333;
  //  background-color: rgba(102, 102, 102, 0.8) !important;
  background-color: #666666;
  transition: width 0.4s,  height 4s;
}
.containr {
  padding: 0px;
}
.el-footer {
  background-color: #f5f7fa;
  color: #333;
  text-align: center;
  line-height: 60px;
}
.el-icon-switch-button {
  font-size: 15px;
}
/deep/ .el-submenu__title:hover {
  background-color: #333333 !important;
   color: #fff;
}

.el-submenu__title:focus, .el-submenu__title:hover {
   background-color: #333333 !important;
}
/deep/ .el-submenu__title {
  background-color: #666666;
  color: #fff !important;
}
.el-menu {
  background-color: rgba(102, 102, 102, 0.8) !important;
    border-right: solid 1px #808080;
  /* background-color: #666666 !important; */
  /* background-color: #333333; */
}
.el-menu-item {
  background-color: #808080;
}
.el-icon-arrow-down:before {
  color: #fff;
}
.el-menu-item {
  /* background-color: #666666; */
  color: #fff;
}
.el-menu-item:focus,
.el-menu-item:hover {
  background-color: #333333 !important;
}
.el-icon-s-unfold {
  float: left;
  color: #fff;
  font-size: 25px;
  /* padding-top: 17px; */
  /* padding-right: 15px; */
  text-align: center;
}
.el-icon-s-unfold:hover {
  color: #333333;
}
.el-icon-s-unfold:active {
  color: #fff;
}
.el-icon-s-fold:active {
  color: #fff;
}
.el-icon-s-fold:hover {
  color: #333333;
}
.el-icon-s-fold {
  float: left;
  color: #fff;
  font-size: 25px;
  color: #333333;
  text-align: center;
  /* padding-top: 17px; */
  /* padding-right: 15px; */
}
.el-button--primary.is-plain {
  background-color: rgba(255, 255, 255, 0.1);
  color: #fff;
  border-color: rgba(255, 255, 255, 0.1);
}
.el-button--primary.is-plain:focus,
.el-button--primary.is-plain:hover {
  background-color: #333333;
  color: #fff;
  border-color: #333333;
}

.el-button--primary.is-plain:active {
  background-color: rgba(255, 255, 255, 0.1);
  color: #fff;
  border-color: rgba(255, 255, 255, 0.1);
}
.el-menu-item.is-active{
  color: #ff2400;
}
/deep/ .el-submenu__title i{color:#fff !important;}
/deep/ .el-menu-item{
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/common/layout.vue